import lodash, { isEmpty } from 'lodash'
import React, { ReactElement, useMemo } from 'react'

import { Col } from '../../../../../../../1stlog-ui/src/components/Bootstrap'
import Field, {
  Label,
  required,
  useField,
} from '../../../../../../../1stlog-ui/src/components/Field'
import useFieldValue from '../../../../../../../1stlog-ui/src/components/Field/useFieldValue'
import Input from '../../../../../../../1stlog-ui/src/components/Input'
import { useProductSettings } from '../../../../Products'

type TContentProps = {
  readonly?: boolean
}

const Content = (props: TContentProps): ReactElement => {
  const { readonly } = props

  const {
    isContentDescriptionAllowed,
    isContentRequired,
    contentDescriptionMandatory,
  } = useProductSettings()

  const content = useFieldValue<string>('content')

  const shipmentServices = useField('shipmentServices', { ignorePrefix: true })

  const isProformaLightEnabled = useMemo(
    () => lodash.some(shipmentServices, (s) => s.name === 'PFL' && s.isEnabled),
    [shipmentServices],
  )

  const isInsuranceEnabled = useMemo(
    () => lodash.some(shipmentServices, (s) => s.name === 'INS' && s.isEnabled),
    [shipmentServices],
  )

  const isRequired = useMemo(
    () =>
      isProformaLightEnabled ||
      isInsuranceEnabled ||
      isContentRequired ||
      contentDescriptionMandatory,
    [
      isProformaLightEnabled,
      isInsuranceEnabled,
      isContentRequired,
      contentDescriptionMandatory,
    ],
  )

  if (!isContentDescriptionAllowed) {
    return <></>
  }

  return (
    <>
      {readonly && !isEmpty(content) && (
        <div className="text-center">
          <Label>{i18n.t('content_of_goods', 'Wareninhalt')}</Label>
          <h5 className="mt-2">{content}</h5>
        </div>
      )}
      <div hidden={readonly}>
        <Field
          key={String(isRequired)}
          name="content"
          label={i18n.t('content_of_goods', 'Wareninhalt')}
          required={isRequired}
          validate={isRequired ? required : undefined}
        >
          <Input />
        </Field>
      </div>
    </>
  )
}

export default Content
